import { Descriptions, List, Tag } from 'antd';
import { Link } from 'react-router-dom';

import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import {
  userProgramRequiredCompleteInformation,
  userProgramRequiredFundAccountReady,
  userProgramRequiredInvestmentPlan,
  userProgramRequiredStartDateEndDateValid,
  userProgramRequiredUser,
  userProgramRequiredUserVerified,
  userProgramStatusColors,
  userProgramStatusPaused,
  userProgramStatusPending,
} from 'apps/investment/constants/userProgram';
import { formatNumber } from 'utils/formatAmount';
import { formatDate, formatDateTime } from 'utils/formatDate';
import { cloudflareCdn } from 'utils/image';

const ItemDetail = ({ item, apiCall }) => {
  const {
    code,
    user_investment_detail,
    user,
    user_id,
    logo,
    photo,
    ...data
  } = item;
  const { id, status, required_active_conditions, ...programDetail } =
    data || {};

  return (
    <Descriptions title="Goal detail" bordered column={1}>
      <Descriptions.Item label={'Status'}>
        <Tag color={userProgramStatusColors[status]}>{item.status_label}</Tag>
      </Descriptions.Item>
      {status == userProgramStatusPending ||
      status == userProgramStatusPaused ? (
        <Descriptions.Item label={'Yêu cầu kích hoạt chương trình'}>
          <List
            size="large"
            header={<div>A) Yêu cầu về chi tiết chương trình:</div>}
            dataSource={[
              {
                label:
                  'Ngày bắt đầu của chương trình đã kích hoạt (đạt hoặc vượt qua) và chưa đến thời điểm / ngày kết thúc',
                condition: userProgramRequiredStartDateEndDateValid,
              },
              {
                label:
                  'Người dùng phải hoàn thành việc chọn danh mục đầu tư (bao gồm đạt các yêu cầu về chọn giá trị đầu tư định kỳ tối thiểu)',
                condition: userProgramRequiredInvestmentPlan,
              },
              {
                label:
                  'Chương trình phải nhập đầy đủ thông tin bao gồm: ngày bắt đầu/kết thúc, giá trị đầu tư định kỳ hàng tháng,...',
                condition: userProgramRequiredCompleteInformation,
              },
            ]}
            renderItem={item => (
              <List.Item>
                - {item.label}{' '}
                {required_active_conditions &&
                required_active_conditions.includes(item.condition) ? (
                  <CloseCircleOutlined
                    style={{ color: 'red', fontSize: '20px' }}
                  />
                ) : (
                  <CheckCircleOutlined
                    style={{ color: 'green', fontSize: '20px' }}
                  />
                )}
              </List.Item>
            )}
          />
          <List
            size="large"
            header={<div>B) Yêu cầu về tài khoản:</div>}
            dataSource={[
              {
                label: 'Người dùng có tài khoản Stag active',
                condition: userProgramRequiredUser,
              },
              {
                label:
                  'Người dùng phải hoàn thành định danh level 3 trên hệ thống Stag (email, phone, eKYC)',
                condition: userProgramRequiredUserVerified,
              },
              {
                label:
                  'Người dùng phải hoàn thành mở tài khoản giao dịch CCQ tại cty QLQ được lựa chọn trong danh mục',
                condition: userProgramRequiredFundAccountReady,
              },
              {
                label:
                  'Người dùng được gắn kết nối giữa tài khoản Stag và tài khoản giao dịch CCQ',
                condition: userProgramRequiredFundAccountReady,
              },
            ]}
            renderItem={item => (
              <List.Item>
                - {item.label}{' '}
                {required_active_conditions &&
                required_active_conditions.includes(item.condition) ? (
                  <CloseCircleOutlined
                    style={{ color: 'red', fontSize: '20px' }}
                  />
                ) : (
                  <CheckCircleOutlined
                    style={{ color: 'green', fontSize: '20px' }}
                  />
                )}
              </List.Item>
            )}
          />
        </Descriptions.Item>
      ) : null}
      <Descriptions.Item label={'User'}>
        <Link to={`/investment/users/${user_id}`}>
          {user?.email || 'View user'}
        </Link>
      </Descriptions.Item>
      <Descriptions.Item label={'Photo'}>
        <img width={400} src={cloudflareCdn(photo || logo, 400)} />
      </Descriptions.Item>
      <Descriptions.Item label="Name">
        {programDetail.program_name}
      </Descriptions.Item>
      <Descriptions.Item label={'Start Date'}>
        {formatDate(programDetail.start_date)}
      </Descriptions.Item>
      <Descriptions.Item label={'End Date'}>
        {formatDate(programDetail.end_date)}
      </Descriptions.Item>
      <Descriptions.Item label={'Contribute Amount'}>
        {formatNumber(programDetail.contribute_amount)}
      </Descriptions.Item>
      <Descriptions.Item label={'Created At'}>
        {formatDateTime(programDetail.created_at)}
      </Descriptions.Item>
      <Descriptions.Item label={'Modifed At'}>
        {formatDateTime(programDetail.updated_at)}
      </Descriptions.Item>
      <Descriptions.Item label={'Monthly Order Payment'}>
        {formatNumber(programDetail.monthly_order_payment)}
      </Descriptions.Item>
      <Descriptions.Item label={'Target Amount'}>
        {formatNumber(programDetail.target_amount)}
      </Descriptions.Item>
      <Descriptions.Item label={'Target Return Ratio'}>
        {formatNumber(programDetail.target_return_ratio)}
      </Descriptions.Item>
      <Descriptions.Item label={'Init Contribute Amount'}>
        {formatNumber(programDetail.init_contribute_amount)}
      </Descriptions.Item>

      <Descriptions.Item label={'Status'}>
        <Tag color={userProgramStatusColors[item.status]}>
          {item.status_label}
        </Tag>
      </Descriptions.Item>
    </Descriptions>
  );
};

export default ItemDetail;
